import { useCallback, useEffect, useState } from "react";
import { Grid, Button, Skeleton } from "@mui/material";
import { isEqual } from "lodash-es";

import AddIcon from "@mui/icons-material/Add";

import { calcZones, useSmartalarm } from "../SmartalarmTemplate";
import { DisplayZoneValue, Partition, SmartalarmUser } from "../types";
import { uuidv4 } from "../../../../../utils/utils";
import Remotecontrol from "./Remotecontrol";
import { useIntl } from "react-intl";
import TitledCard from "../../TitledCard";

const Remotecontrols = () => {
  const [remoteIds, setRemoteIds] = useState<string[] | null>(null);
  const [partitions, setPartitions] = useState<Partition[]>([]);
  const [zones, setZones] = useState<DisplayZoneValue[]>([]);
  const [users, setUsers] = useState<SmartalarmUser[]>([]);

  const { value, saved, setValue } = useSmartalarm();

  const { formatMessage } = useIntl();

  const addNewRemote = useCallback(() => {
    value.remotecontrol.push({ name: "", uuid: uuidv4(), buttons: [null, null, null, null], physical: [], newItem: true });
    setRemoteIds(value.remotecontrol.map((r) => r.uuid));
    setValue(value);
  }, [value, setValue]);

  const onRemoteChange = useCallback(
    (index, v) => {
      value.remotecontrol[index] = v;
      setValue(value);
    },
    [value, setValue]
  );

  useEffect(() => {
    if (!value) {
      return;
    }
    // const usedPartitions = value.plists.partitions
    //   .filter(
    //     (p) =>
    //       value.remotecontrol
    //         .map((r) => r.buttons.map((b) => b?.partition))
    //         .flat()
    //         .filter((b) => b === p.uuid).length > 0
    //   )
    //   .map((p) => p.uuid);
    // const filteredPartitions = value.plists.partitions.filter((p) => !p.technical || usedPartitions.includes(p.uuid));
    setPartitions((old) => (isEqual(old, value.plists.partitions) ? old : value.plists.partitions || []));
    setZones((old) => {
      const newZones = calcZones(value.panels);
      return isEqual(old, newZones) ? old : newZones;
    });
    setUsers((old) => (isEqual(old, value.users) ? old : value.users || []));
    value.remotecontrol.forEach((remote) => {
      if (!remote.uuid) {
        remote.uuid = uuidv4();
      }
    });
    setRemoteIds((old) => {
      const ids = value.remotecontrol.map((r) => r.uuid);
      return isEqual(old, ids) ? old : ids;
    });
  }, [value]);

  if (!remoteIds) {
    return (
      <TitledCard>
        <Grid container spacing={1} sx={{ padding: 1 }}>
          <Grid item>
            <Skeleton variant="rectangular" height={32} width={110} sx={{ borderRadius: 16 }} />
          </Grid>
          <Grid item>
            <Skeleton variant="rectangular" height={32} width={110} sx={{ borderRadius: 16 }} />
          </Grid>
          <Grid item>
            <Skeleton variant="rectangular" height={32} width={110} sx={{ borderRadius: 16 }} />
          </Grid>
        </Grid>
      </TitledCard>
    );
  }
  return (
    <Grid container spacing={1}>
      {remoteIds.length === value.remotecontrol.length &&
        remoteIds.map((id, index) => (
          <Grid item xs={12} key={`remote-${id}`}>
            <Remotecontrol
              index={index}
              value={value.remotecontrol[index]}
              saved={saved?.remotecontrol?.[index] || null}
              zones={zones}
              partitions={partitions}
              users={users}
              onChange={onRemoteChange}
            />
          </Grid>
        ))}
      <Grid item xs={12}>
        <Button startIcon={<AddIcon />} onClick={() => addNewRemote()}>
          {formatMessage({ defaultMessage: "New remote configuration" })}
        </Button>
      </Grid>
    </Grid>
  );
};

export default Remotecontrols;
